<div class="container-fluid tp-box" [@flipState]="flip" >
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">wb_cloudy</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Over Due Customers {{ title }}</span>
				</div>
			</div>
			<div class="cw-body"  *ngIf="viewing">
				<app-trial-balance
					[data]="viewing"
					[salesmenCatalog]="trialBalanceSalesmen"
					[brandsCatalog]="trialBalanceBrands"
					[customerViewTab]="'transactions'"
					[showAccountOverviewAction]="trialBalanceShowAccountOverview"
					[showPaymentAction]="trialBalanceShowTakePayment"
					[showToolbarRefresh]="true"
					[toolbarRefreshDisabled]="isTrialBalanceLoading"
					(toolbarRefresh)="refreshReport()"
					(accountOverview)="openCustomerAccountOverview($event)"
					(takePayment)="openCustomerPayment($event)"
				></app-trial-balance>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Over Due Customers"
				icon="wb_cloudy"
				accent="info"
				[value]="total_overdue_details?.total"
				[loading]="isTrialBalanceLoading"
				[buckets]="overdueBuckets"
				(bucketView)="onOverdueBucket($event)"
				(view)="toggleFlip(original_trialbalance, 'All')">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
